module.exports = __webpack_public_path__ + "static/media/vtho.4423d896.svg";